import React, { useState, useEffect } from 'react';
import { Grid, Container, Alert } from '@mui/material';
import EventNav from './EventNav';
import CheckoutMap from './CheckoutMap';
import useEventContext from '@/contexts/event/useEventContext';
import EventInfo from './EventNav/EventInfo';
import HeaderDesktop from './HeaderDesktop';
import CheckoutHomeDesktopLayout from '../layouts/CheckoutHomeDesktopLayout';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import useEventStatus from '@/contexts/event/useEventStatus';
import EventEmpty from '@/assets/illustration_EventEmpty';
import CustomLinkBanner from '@/sections/custom-links/CustomLinkBanner';
import { useSaturated } from '@/store';
import Saturated from '@/templates/plus/sections/saturated';
import { useCustomLinksActions } from '@/store';

export default function EventCartDesktop() {
  const { showEventDetails } = useAnalyticsEvents();
  const [view, setView] = useState();
  const [show, setShow] = useState(false);
  const { eventStatus } = useEventStatus();
  const {
    event: {
      event: { use_seats, id },
    },
  } = useEventContext();

  const {
    customLink: { linkStatus },
  } = useCustomLinksActions();

  const onCloseEventInfoHandler = () => {
    setView('home');
  };
  const onReadMoreHandler = () => {
    setView('info');
    showEventDetails();
  };
  const onTicketCategorySelectedHandler = () => {
    setView('summary');
  };

  const { isEnabled } = useSaturated();

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <>
      <HeaderDesktop showEventInfo={view === 'summary'} />
      <CheckoutHomeDesktopLayout>
        <Grid container spacing={2} sx={{ height: '100%', marginTop: '0px' }}>
          <Grid
            item
            md={use_seats ? 5 : 6}
            sx={{
              height: '100%',
              backgroundColor: (theme) => theme.palette.background.default,
              boxShadow: (theme) => theme.customShadows.side,
              pt: 0,
              overflow: 'hidden',
            }}
          >
            <EventNav
              view={view}
              onCloseEventInfo={onCloseEventInfoHandler}
              onReadMore={onReadMoreHandler}
              onTicketCategorySelected={onTicketCategorySelectedHandler}
            />
          </Grid>
          <Grid
            item
            md={use_seats ? 7 : 6}
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'scroll',
            }}
          >
            {show && (
              <>
                {(eventStatus === 'active' || eventStatus === 'pre-sale') &&
                  (linkStatus === 'active' || !linkStatus) && (
                    <>
                      <CustomLinkBanner />
                      {use_seats && (
                        <CheckoutMap
                          onHold={onTicketCategorySelectedHandler}
                          view={view}
                        />
                      )}
                    </>
                  )}

                {(eventStatus === 'active' || eventStatus === 'pre-sale' || eventStatus === 'soldout' || eventStatus === 'not-on-sale') &&
                  (linkStatus === 'active' || !linkStatus) && (
                    <>
                      {!use_seats && (
                        <Container>
                          {id === 219293 && (
                            <Alert
                              sx={{
                                '& .MuiAlert-icon': {
                                  fontSize: 40,
                                  color: '#1B8FFF',
                                },
                                'mb': 2,
                              }}
                              severity="info"
                            >
                              ¡20%off en todos los boletos!!! Activa el cupón
                              TODOS20 para hacer válida la promoción
                            </Alert>
                          )}
                          {isEnabled && <Saturated disableTries />}
                          <EventInfo />
                        </Container>
                      )}
                    </>
                  )}


                {(linkStatus === 'inactive' ||
                  linkStatus === 'expired' ||
                  linkStatus === 'used' ||
                  eventStatus === 'inactive' ||
                  eventStatus === 'expired' ||
                  ((eventStatus === 'soldout' || eventStatus === 'not-on-sale') && use_seats) ||
                  eventStatus === 'link-expired') && (
                    <>
                      <EventEmpty
                        sx={{
                          height: '100%',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                    </>
                  )}
              </>
            )}
          </Grid>
        </Grid>
      </CheckoutHomeDesktopLayout>
    </>
  );
}
